export const calculateTotalPremium = (benefits: any[]) => {
	return benefits.reduce((total: any, benefit: { total_premium: any }) => total + benefit.total_premium, 0);
};
